
import { useRef, useState } from "react";
import { Box, Grid, MenuItem, TextField } from "@mui/material"
import { AutocompleteConLoading } from "../../components";
import { BotonesAndCargando } from "../../components/botones";
import { useModalStore } from "../../../stores";
import { useQueryClient } from "@tanstack/react-query";
import { asignarColaborador, listadoUsuariosColaborador } from "../../../services";
import { itemProduccion } from "../../../data";

import Swal from "sweetalert2";




export const FormularioAsignarColaborador = ({ selected, setSelected }) => {


    const debounceRef = useRef(null);
    const queryClient = useQueryClient();
    const { modalFormToggle } = useModalStore();
    const [userValue, setUserValue] = useState({ user: '', area: '' });  
    const [cargando, setCargando] = useState(false)
    const [optiones, setOpciones] = useState([]);



    const buscarUsuario = (texto) => {
        if(debounceRef.current){ clearTimeout(debounceRef.current); }
        debounceRef.current = setTimeout(async () => {
            const query = texto.trim();
            if(query.length === 0) return;

            setCargando(true);
            const respuesta = await listadoUsuariosColaborador(texto); 
            setOpciones(respuesta)
            setCargando(false);
        }, 700);
    };



    const handleEntregarTrabajo = async (e) => {
        e.preventDefault();
        const { isConfirmed } = await Swal.fire({
            title: 'Asignar Items de Trabajo',
            text: '¿Está seguro de asignar estos ítems de trabajo?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, seguro'
        });

        if (!isConfirmed) return;

        const resp = await asignarColaborador({ user:userValue.user, area:userValue.area,  items:selected });
        if( resp ){
            queryClient.invalidateQueries({ queryKey: ['disponibles-trabajo'] });
            queryClient.invalidateQueries({ queryKey: ['misitems-trabajo'] });
            modalFormToggle(false);
            if( setSelected ){ setSelected([]); }
        }
    }



    return (
        <Box>
            <form  onSubmit={ handleEntregarTrabajo } >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <AutocompleteConLoading
                            size="small"
                            label="Buscar Colaborador" 
                            placeholder='Buscar Colaborador' 
                            fullWidth
                            name="colaborador"
                            options={optiones}
                            value={userValue.user}
                            loading={cargando}
                            onChange={(newValue) => setUserValue(item => ({ ...item, user: newValue }))}
                            handleFunction={ (value) => buscarUsuario(value) }
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            required
                            variant="outlined"
                            select
                            label="Seleccione Area"
                            fullWidth
                            name='area'
                            value={userValue.area}
                            onChange={({ target }) => setUserValue(item => ({ ...item, area: target.value }))}
                            size="small"
                        >
                            <MenuItem value="">Seleccione Area</MenuItem>
                            {itemProduccion.map( item => (
                                <MenuItem key={item} value={item}>{ item }</MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>

                <Grid container sx={{mb:2, mt:3, display:'flex', justifyContent:'center' }}>
                    <Grid item xs={12} sm={6}>
                        <BotonesAndCargando
                            cargando={cargando}
                            titulo='Asignar Colaborador'
                            titulo2="Loading..."
                            icon1="save"
                            icon2="save"
                            esSubmit
                        />
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}